// Service Worker 注册（缓存外壳、离线提示骨架）。
// 仅在生产构建且浏览器支持时注册，避免开发期缓存干扰。

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  if (!import.meta.env.PROD) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // 注册失败不应阻断应用：仅记录。
      console.warn("Service Worker 注册失败", err);
    });
  });
}
